import { render } from "./StoreInformations.vue?vue&type=template&id=4f59bd00&scoped=true"
import script from "./StoreInformations.vue?vue&type=script&lang=ts"
export * from "./StoreInformations.vue?vue&type=script&lang=ts"

import "./StoreInformations.vue?vue&type=style&index=0&id=4f59bd00&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4f59bd00"

export default script